export default __webpack_public_path__ + "locales/it/PeopleTranslations.json?hash=72c632b74696bf760125427bff919793";